export const Logo = ({ size = 32, className = "" }) => (
  <img
    src="/coparent-logo.png?v=3"
    alt="CoParent Console"
    width={size}
    height={size}
    className={`rounded-full object-cover ${className}`}
    data-testid="brand-logo-image"
  />
);

export default Logo;
